import React, { useEffect, useState } from "react";
import {
  Route,
  useLocation,
  Navigate,
  Routes,
  useParams,
  useNavigate,
} from "react-router-dom";

// for boostrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.slim";
import "popper.js/dist/umd/popper";
import "bootstrap/dist/js/bootstrap";

///GA
import i18n from './i18n';

// import { initGA, logPageView } from "./utils/analytics";
import ReactGA from 'react-ga4';
import Login from "./components/auth/login";
import Register from "./components/auth/register";
import { ScanProduct } from "./components/pages/productScan/ScanProduct";
import { OTPverification } from "./components/auth/sendotp";
import { SelectPayment } from "./components/pages/payments/SelectPayment";
import { BankDetails } from "./components/pages/payments/BankDetails";
import { UpiDetails } from "./components/pages/payments/UpiDetails";
import { ClaimDetails } from "./components/pages/myrewards";
import { ProtectedRoute } from "./components/auth/protectedRoute";
import { TransactionDetails } from "./components/pages/transactions";
import { logout, scanData, store } from "./components/auth/redux/store";
import { useDispatch } from "react-redux";
import persistStore from "redux-persist/es/persistStore";
import { PURGE } from "redux-persist";
import { Reward } from "./components/pages/reward";
import Home from "./components/pages/home";
import { useTranslation } from "react-i18next";
import { parseQueryParams } from "../src/utils";
import { TransferSucces } from "./components/pages/payments/TransferSucces";
import { decryptJSON, encryptJSON } from "./components/service/Encrtyption";
import SaltGenerator from "./components/hooks/SaltGenerator";
import { TermsandConditions } from "./components/pages/termsandconditions";
import { TermsandConditionsMbl } from "./components/pages/termsandconditions/termsandConditionsMbl";
import { PrivacyConsentNotice } from "./components/pages/privacyConsent";
import CustomModal from "./components/modal";
import { Button } from "react-bootstrap";
import SpinImageHi from "./assets/images/spinImage_hi.png";
import SpinImageMr from "./assets/images/spinImage_mr.png";
import SpinImageKa from "./assets/images/spinImage_ka.png";
import SpinImageTe from "./assets/images/spinImage_te.png";
import SpinImagePb from "./assets/images/spinImage_pb.png";
import SpinImageGj from "./assets/images/spinImage_gj.png";
import SpinImageTa from "./assets/images/spinImage_ta.png";
import SpinImageBn from "./assets/images/spinImage_ba.png";
import SpinImageEn from "./assets/images/spinImage_en.png";
import SpinImageOr from "./assets/images/spinImage_or.png";
import SpinImageMa from "./assets/images/spinImage_ma.png";

import StepsImageHi from "./assets/images/hindiSteps.png";
import StepsImageMr from "./assets/images/martahiSteps.png";
import StepsImageKa from "./assets/images/kanndaSteps.png";
import StepsImageTe from "./assets/images/teluguSteps.png";
import StepsImagePb from "./assets/images/punjabiSteps.png";
import StepsImageGj from "./assets/images/gujaratiSteps.png";
import Congratulations from "./components/pages/congratulations";
import RewardJourney from "./components/pages/rewardJourney";
import VerifyOtp from "./components/pages/verifyOtp";
import { TransferFailed } from "./components/pages/payments/TransferFailed";
import { AwardSummary } from "./components/pages/payments/AwardSummary";
import { AwardShare } from "./components/pages/payments/AwardShare";
import { ConfirmBankDetails } from "./components/pages/payments/ConfirmBankDetails";
import { NotFoundRedirect } from "./components/routing/NotFoundRedirect";
import FromFcEntry from "./components/pages/fromFc";
import { resolveLang } from "./utils/navigation";


function App() {
  const location = useLocation();
  const { query } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [uParamValue, setUParamValue] = useState('');
  const [videoModal, setvideoModal] = useState(true);
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { pathname } = useLocation();

  // console.log(query, "#########setvideoModal#####33");
  useEffect(() => {
    const queryString = window?.location?.href?.split("?")[1];
    const queryParams = {};
    queryString?.split("&")?.forEach((pair) => {
      const [key, value] = pair?.split("=");
      queryParams[key] = value;
    });
    const uParamValue = queryParams["u"];
    if (uParamValue !== null && uParamValue !== "" && uParamValue !== undefined) {
      try {
        const decryptedData = decryptJSON(uParamValue);
        if (!decryptedData) return;
        console.log("DECRYTPDATE----------" + JSON.stringify(decryptedData));
        const jsonObject = JSON.parse(decryptedData);
        const resproductName = jsonObject.product.toLowerCase();
        sessionStorage.setItem('storedProductName', resproductName);
        sessionStorage.setItem('k', encryptJSON(queryString));
        dispatch(scanData(jsonObject));
      } catch (error) {
        console.error("Failed to parse scan URL parameter:", error);
      }
    }

    const ufromFc = queryParams["ufromFc"];
    if (ufromFc && !location.pathname.includes("/from-fc")) {
      sessionStorage.setItem("ufromFcPayload", ufromFc);
      const pathParts = location.pathname.split("/").filter(Boolean);
      const langSeg = resolveLang(pathParts[0]);
      navigate(
        `/${langSeg}/from-fc?ufromFc=${encodeURIComponent(ufromFc)}`,
        { replace: true }
      );
    }

    const handleBeforeUnload = (event) => {
      sessionStorage.removeItem("userData");
      // const confirmationMessage = 'Are you sure you want to leave?';
      // event.returnValue = confirmationMessage;
      // return confirmationMessage;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [dispatch, location, navigate]);

  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const lang = pathParts[1];
    if (['mr', 'hi', 'kn', 'te', 'pa', 'gu', 'en', 'ta', 'or', 'bn', 'ma'].includes(lang)) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage('hi');
    }
  }, [location]);

  // UAT GA
  ReactGA.initialize('G-7KBJBJ35F3', {
    // LIVE GA
    // ReactGA.initialize('G-S692RV19XW', {
    debug: true,
    testMode: false,
    gaAddress: 'https://ssl.google-analytics.com/ga.js',
  });

  useEffect(() => {
    // debugger;
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  useEffect(() => {
    // console.clear();
    window.scrollTo(0, 0);
  }, [pathname]);


  let bannerLogoSrc;
  if (lang === 'hi') {
    bannerLogoSrc = SpinImageHi;
  } else if (lang === 'mr') {
    bannerLogoSrc = SpinImageMr;
  } else if (lang === 'kn') {
    bannerLogoSrc = SpinImageKa;
  } else if (lang === 'te') {
    bannerLogoSrc = SpinImageTe;
  } else if (lang === 'pa') {
    bannerLogoSrc = SpinImagePb;
  } else if (lang === 'gu') {
    bannerLogoSrc = SpinImageGj;
  } else if (lang === 'ta') {
    bannerLogoSrc = SpinImageTa;
  } else if (lang === 'bn') {
    bannerLogoSrc = SpinImageBn;
  } else if (lang === 'en') {
    bannerLogoSrc = SpinImageEn;
  } else if (lang === 'or') {
    bannerLogoSrc = SpinImageHi;
  } else if (lang === 'ma') {
    bannerLogoSrc = SpinImageHi;
  }
  else {
    bannerLogoSrc = SpinImageHi;
  }
  ///process Img
  let StepsImg;
  if (lang === 'hi') {
    StepsImg = StepsImageHi;
  } else if (lang === 'mr') {
    StepsImg = StepsImageMr;
  } else if (lang === 'kn') {
    StepsImg = StepsImageKa;
  } else if (lang === 'te') {
    StepsImg = StepsImageTe;
  } else if (lang === 'pa') {
    StepsImg = StepsImagePb;
  } else if (lang === 'gu') {
    StepsImg = StepsImageGj;
  } else {
    StepsImg = StepsImageHi;
  }

  useEffect(() => {
    if (location.pathname === "/transferSucces") {
      // Add current page to history
      window.history.pushState(null, "", window.location.href);
      const onPopState = () => {
        navigate(`/${lang}/home`, {
          replace: true,
          state: { menutonavigate: 1 },
        });
      };
      window.addEventListener("popstate", onPopState);
      return () => {
        window.removeEventListener("popstate", onPopState);
      };
    }
  }, [location.pathname, navigate]);

  const userAgent = navigator.userAgent;

let browser = "Unknown Browser";

if (userAgent.includes("Edg")) {
  browser = "Microsoft Edge";
} else if (
  userAgent.includes("Chrome") &&
  !userAgent.includes("Edg")
) {
  browser = "Google Chrome";
} else if (
  userAgent.includes("Safari") &&
  !userAgent.includes("Chrome")
) {
  browser = "Safari";
} else if (userAgent.includes("Firefox")) {
  browser = "Mozilla Firefox";
}

sessionStorage.setItem("browserName", browser);

console.log("Stored Browser:", sessionStorage.getItem("browserName"));

  return (
    <>

      {/* //stpes image */}
      {/* <CustomModal
        id={"videoModal"}
        title=""
        content={
          <>
            <iframe
              width="100%"
              height="410"
              src="https://www.youtube.com/embed/gL9vUtWjMvQ?autoplay=1&loop=1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
              style={{ borderRadius: '10px' }}>
            </iframe>
          </>
        }
        footer={
          <>
            <Button className="px-4 rounded-4 py-2" onClick={() => setvideoModal(false)}>
              {t("Skip")}
            </Button>
          </>
        }
        show={videoModal}
        onHide={() => setvideoModal(false)}
      /> */}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/:lang" element={<Login />} />
        <Route path="/:lang/" element={<Login />} />
        <Route path="/:lang/login" element={<Login />} />
        <Route path="/:lang/register" requireOtp element={<Register />} />
        <Route path="/:lang/congratulations" requireOtp element={<Congratulations />} />
        <Route path="/:lang/rewardjourney" requireOtp element={<RewardJourney />} />
        <Route path="/:lang/verify" requireOtp element={<OTPverification />} />
        <Route path="/:lang/strongarmdhamaka" element={<TermsandConditions />} />
        <Route path="/:lang/termsandConditionsMbl" element={<TermsandConditionsMbl />} />
        <Route path="/:lang/privacy-consent" element={<PrivacyConsentNotice />} />
        <Route path="/:lang/verifyOtp" element={<VerifyOtp />} />
        <Route path="/from-fc" element={<FromFcEntry />} />
        <Route path="/:lang/from-fc" element={<FromFcEntry />} />
        <Route path="/:lang/transferFailed" element={<TransferFailed />} />
        <Route path="/:lang/transferSucces" element={<TransferSucces />} />
        <Route path="/:lang/awardsummary" requireOtp element={<AwardSummary />} />
        <Route path="/:lang/awardshare" requireOtp element={<AwardShare />} />
        <Route path="/:lang/confirmBankDetails" requireOtp element={<ConfirmBankDetails />} />
        <Route path="/:lang/home" requireOtp element={<Home />} />
        <Route path="/:lang/scanProduct" requireOtp element={<ScanProduct />} />
        <Route path="/:lang/paymentmode" requireOtp element={<SelectPayment />} />
        <Route path="/:lang/upidetails" requireOtp element={<UpiDetails />} />
        <Route path="/:lang/bankdetails" requireOtp element={<BankDetails />} />
        <Route path="/:lang/Reward" requireOtp element={<Reward />} />
        <Route path="/:lang/myrewards" requireOtp element={<ClaimDetails />} />
        <Route path="/:lang/transactions" requireOtp element={<TransactionDetails />} />
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>

    </>



  );
}
export default App;
